// components/OrderComplete.js
import React from "react";
import { Link } from "react-router-dom";
import { CONTACT } from "../../config/location";
import { euro } from "../order/orderUi";

const OrderComplete = ({ order }) => {
    const paymentNote = order.pickup ? "bar oder mit Karte" : "nur Barzahlung";

    return (
        <section className="sec page-head grid-2 pb-[140px]">
            <div className="eyebrow">Bestellung</div>
            <div className="max-w-[640px]">
                <h1 className="h1-page mb-5 !text-[clamp(36px,4.5vw,64px)] !leading-[1.05]">
                    Vielen Dank für Ihre Bestellung.
                </h1>
                <p className="body-text mb-8">
                    Wir prüfen Ihre Bestellung und bestätigen sie in Kürze per E-Mail.
                </p>
                <div className="grid max-w-[480px] grid-cols-[auto_1fr] gap-x-8 gap-y-3 border-t border-forest pt-5 text-base">
                    <span className="text-forest/70">Bestellnummer</span>
                    <span className="font-caslon text-[22px]">{order.orderNumber}</span>
                    <span className="text-forest/70">Art</span>
                    <span>{order.pickup ? "Abholung am Restaurant" : "Lieferung"}</span>
                    {!order.pickup && (
                        <>
                            <span className="text-forest/70">Lieferadresse</span>
                            <span>
                                {order.formData.street}, {order.formData.zipCode} {order.formData.city}
                            </span>
                        </>
                    )}
                    <span className="text-forest/70">Gesamt</span>
                    <span className="tabular-nums">{euro(order.totalPrice)}</span>
                    <span className="text-forest/70">Bezahlung</span>
                    <span>vor Ort, {paymentNote}</span>
                </div>

                {order.cart && order.cart.length > 0 && (
                    <div className="mt-10 max-w-[480px]">
                        <div className="eyebrow mb-2">Bestellte Artikel</div>
                        {order.cart.map((item) => (
                            <div
                                key={item.id + item.beilage}
                                className="flex justify-between gap-4 border-b border-forest/10 py-3 text-[15px]"
                            >
                                <span>
                                    {item.quantity} × {item.title}
                                    {item.beilage && <span className="text-forest/70"> mit {item.beilage}</span>}
                                    {item.customerComment && (
                                        <span className="block text-sm text-forest/70">
                                            {item.customerComment}
                                        </span>
                                    )}
                                </span>
                                <span className="tabular-nums">{euro(item.price * item.quantity)}</span>
                            </div>
                        ))}
                    </div>
                )}

                <div className="mt-10 flex flex-wrap items-center gap-6">
                    <Link to="/" className="btn btn-primary">
                        Zur Startseite
                    </Link>
                    <span className="text-sm text-forest/70">
                        Fragen?{" "}
                        <a href={`mailto:${CONTACT.email}`} className="underline">
                            {CONTACT.email}
                        </a>
                    </span>
                </div>
            </div>
        </section>
    );
};

export default OrderComplete;
